import { Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SharedCommonService implements OnDestroy {
  subscriptions: Subscription = new Subscription();
  isMobileResolution = false;
  constructor(private breakpointObserver: BreakpointObserver) {
    // detect screen size changes
    this.subscriptions.add(this.breakpointObserver
      .observe(["(max-width: 767px)"])
      .subscribe((result: BreakpointState) => {
        this.isMobileResolution = result.matches
    }));
  }

  public hasClass(el: Element, name: string): any {
    return new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)').test(el.className);
  }

  public addClass(el: Element, name: string): void {
    if (!this.hasClass(el, name)) {
      el.className = el.className ? [el.className, name].join(' ') : name;
    }
  }

  public removeClass(el: Element, name: string): void {
    if (this.hasClass(el, name)) {
      el.className = el.className.replace(new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)', 'g'), '');
    }
  }

  downloadPrint(blob: any, name: string) {
    if (this.checkIsIEOrEdge) {
      const anchor = window.document.createElement('a');
      anchor.href = URL.createObjectURL(blob);
      anchor.download = name;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(anchor.href);
    } else {
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, '_blank');
    }
  }

  patternmatch(stringToMatch: string, regex: string | RegExp) {
    const regexp = new RegExp(regex);
    return regexp.test(stringToMatch);
  }

  public get checkIsIEOrEdge() {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    return isIEOrEdge || /Edge/.test(navigator.userAgent);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
